import { render, staticRenderFns } from "./IconsSelector.vue?vue&type=template&id=667d9a15&scoped=true"
import script from "./IconsSelector.vue?vue&type=script&lang=ts"
export * from "./IconsSelector.vue?vue&type=script&lang=ts"
import style0 from "./IconsSelector.vue?vue&type=style&index=0&id=667d9a15&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "667d9a15",
  null
  
)

export default component.exports